import React from 'react';
import { motion, useScroll, useTransform, useReducedMotion, MotionValue } from 'framer-motion';
interface Orb {
  size: number;
  color: string;
  x: string;
  y: string;
  speed: number; // hoe snel ie meebeweegt met scroll (negatief = sneller omhoog)
  blur: number;
}
const ORBS: Orb[] = [{
  size: 560,
  color: 'rgba(251, 146, 60, 0.22)',
  x: '-12%',
  y: '5%',
  speed: 260,
  blur: 120
}, {
  size: 480,
  color: 'rgba(168, 85, 247, 0.16)',
  x: '78%',
  y: '8%',
  speed: -220,
  blur: 110
}, {
  size: 640,
  color: 'rgba(245, 158, 11, 0.14)',
  x: '85%',
  y: '38%',
  speed: 360,
  blur: 140
}, {
  size: 520,
  color: 'rgba(16, 185, 129, 0.12)',
  x: '-8%',
  y: '55%',
  speed: -300,
  blur: 120
}, {
  size: 600,
  color: 'rgba(244, 114, 182, 0.12)',
  x: '70%',
  y: '78%',
  speed: 220,
  blur: 130
}, {
  size: 460,
  color: 'rgba(56, 189, 248, 0.12)',
  x: '5%',
  y: '88%',
  speed: -260,
  blur: 100
}];
function OrbLayer({
  orb,
  scrollY,
  reduced
}: {
  orb: Orb;
  scrollY: MotionValue<number>;
  reduced: boolean;
}) {
  const y = useTransform(scrollY, [0, 3000], [0, reduced ? 0 : orb.speed]);
  return <motion.div aria-hidden="true" className="absolute rounded-full pointer-events-none will-change-transform" style={{
    width: orb.size,
    height: orb.size,
    left: orb.x,
    top: orb.y,
    background: orb.color,
    filter: `blur(${orb.blur}px)`,
    mixBlendMode: 'multiply',
    y
  }} data-id="element-538" />;
}
/**
 * Globale parallax-laag: 6 drijvende gekleurde orbs achter de hele pagina.
 * Respecteert prefers-reduced-motion en gebruikt mix-blend-mode voor rijkere look.
 */
export function ParallaxOrbs() {
  const {
    scrollY
  } = useScroll();
  const reduced = useReducedMotion() ?? false;
  return <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" data-id="element-539">
      {/* Grid texture overlay */}
      <div className="absolute inset-0 opacity-[0.025]" style={{
      backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)',
      backgroundSize: '64px 64px'
    }} data-id="element-540" />
      {/* Floating orbs */}
      {ORBS.map((orb, i) => <OrbLayer key={i} orb={orb} scrollY={scrollY} reduced={reduced} data-id="element-541" />)}
    </div>;
}